const HotjarMask = ({ children }: any) => (
  <span data-hj-masked>{children}</span>
);

export default HotjarMask;
